module.exports = __webpack_public_path__ + "static/media/Ratnesh.81e9c584.webp";